/** Shapes for the Mindmaps dataset.
 *  The supplied JavaScript data is the single source of truth — nothing here
 *  generates, infers or modifies academic content. */

import type { ExamId, SubjectId } from "@/lib/pyq/types";

export type { ExamId, SubjectId };

/** A node of the supplied knowledge tree. Children nest to any depth. */
export interface MindmapNode {
  name: string;
  children?: MindmapNode[];
}

/** A chapter-level mindmap derived from the supplied tree (no content added). */
export interface Mindmap {
  id: string;
  chapter: string;
  /** The group the chapter sits under, e.g. "Class 11 Physics". */
  group: string;
  subject: SubjectId;
  nodes: MindmapNode[];
}

/** Which subjects each exam shows. Structure only — no content. */
export const EXAM_SUBJECTS: Record<ExamId, SubjectId[]> = {
  jee: ["physics", "chemistry", "math"],
  neet: ["physics", "chemistry", "biology"],
};
